import { render, staticRenderFns } from "./Snake.vue?vue&type=template&id=6f23b8d9&"
import script from "./Snake.vue?vue&type=script&lang=js&"
export * from "./Snake.vue?vue&type=script&lang=js&"
import style0 from "./Snake.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports